// Material-UI
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

// icons
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ProductCardSkeleton from 'components/Product/ProductCard/ProductCardSkeleton';

const ProductCardsCarouselSkeleton = ({ page, isAuthenticated }: { page: string; isAuthenticated: boolean }) => {
  return (
    <Box
      data-testid="skeleton-content-wrapper"
      sx={{
        position: 'relative',
        marginBottom: {
          xs: page === 'cart' ? '40px' : '20px',
          md: page === 'cart' ? '10px' : '5px',
        },
        mr: '10px',
        ml: '-10px',
      }}
    >
      <Stack
        gap={1}
        direction="row"
        alignItems="center"
        sx={{ position: 'relative' }}
        data-testid="carousel-grouped-skeletons"
      >
        {/* left arrow */}
        <Box
          sx={{
            position: 'absolute',
            left: '-2.2rem',
            top: '50%',
            transform: 'translateY(-50%)',
            display: { xs: 'none', md: 'block' },
          }}
          width={50}
          height={50}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1,
              width: 40,
              height: 40,
              transition: 'all 0.2s ease-in-out',

              '& .MuiSvgIcon-root': {
                fontSize: '50px',
              },
            }}
          >
            <ChevronLeftIcon color="primary" />
          </Box>
        </Box>

        {/* carousel */}
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{
            width: '100%',
            pl: 0.5,
            pr: { xs: 0, md: 1.7 },
          }}
          data-testid="carousel-skeleton-wrapper"
        >
          {[...Array(5)].map((i, index) => (
            <Box
              key={`product-skeleton-${index + 1}`}
              sx={{
                px: 0.5,
                pt: { xs: 0, md: 2 },
                pb: { xs: 1, md: 2 },
                display: 'inline-block',
                '@media (max-width:959px)': {
                  display: index > 1 ? 'none' : 'inline-block',
                },
                '@media (min-width:960px) and (max-width:1160px)': {
                  display: index > 2 ? 'none' : 'inline-block',
                },
                '@media (min-width:1161px) and (max-width:1280px)': {
                  display: index > 3 ? 'none' : 'inline-block',
                },
                '@media (min-width:1281px)': {
                  display: 'inline-block',
                },
                '@media (max-width:600px)': {
                  width: '50%',
                },
              }}
            >
              <ProductCardSkeleton isAuthenticated={isAuthenticated} />
            </Box>
          ))}
        </Stack>

        {/* right arrow */}
        <Box
          sx={{
            position: 'absolute',
            right: '2rem',
            top: '50%',
            transform: 'translateY(-50%)',
            display: { xs: 'none', md: 'block' },
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 1,
              width: 40,
              height: 40,
              transition: 'all 0.2s ease-in-out',

              '& .MuiSvgIcon-root': {
                fontSize: '50px',
              },
            }}
          >
            <ChevronRightIcon color="primary" />
          </Box>
        </Box>
      </Stack>

      {/* carousel dots */}
      <Box data-testid="skeleton-carousel-dots" display="flex" alignItems="center" justifyContent="center">
        <Box
          sx={{
            display: 'none',
            '@media (max-width:1280px)': {
              display: 'block',
            },
          }}
        >
          <Skeleton height={27.5} width={150} />
        </Box>
      </Box>
    </Box>
  );
};

export default ProductCardsCarouselSkeleton;
